<mat-card fxLayoutAlign="center center" fxLayout="column" class="alert alert-warning">
  <mat-card-content fxLayout="row">
    <mat-icon class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></mat-icon> &nbsp; Accès non autorisé à l'application
  </mat-card-content>
</mat-card>
